/* global toastr $ */

import React, { Component } from 'react'

const MODAL_ID = 'modal_activate_access_objects'

export class AccessObjectsActivateModal extends Component {
  constructor(props) {
    super(props)
    this.state = {
      items: [],
      selectedIds: new Set(),
      loading: false,
      applying: false,
      modalPage: 1,
      modalTotalPages: 1,
      isModalSelectedAll: false,
    }
    this.loadItems = this.loadItems.bind(this)
    this.toggleItem = this.toggleItem.bind(this)
    this.apply = this.apply.bind(this)
    this.resetState = this.resetState.bind(this)
    this.handleSelectAllFound = this.handleSelectAllFound.bind(this)
  }

  componentDidMount() {
    $(`#${MODAL_ID}`).on('show.bs.modal', this.loadItems)
    $(`#${MODAL_ID}`).on('hidden.bs.modal', this.resetState)
  }

  componentWillUnmount() {
    $(`#${MODAL_ID}`).off('show.bs.modal', this.loadItems)
    $(`#${MODAL_ID}`).off('hidden.bs.modal', this.resetState)
  }

  resetState() {
    this.setState({
      items: [],
      selectedIds: new Set(),
      loading: false,
      applying: false,
      isModalSelectedAll: false,
      modalPage: 1,
      modalTotalPages: 1,
    })
  }

  loadItems(e, page = 1) {
    const token = localStorage.getItem('auth_access_token')
    this.setState({ loading: true, selectedIds: new Set() })
    fetch(`/api/${this.props.project_name}/drafts_for_activation/${page}`, {
      method: 'GET',
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    })
      .then((response) => {
        if (!response.ok) {
          return response.json().then((err) => {
            throw new Error(err.detail || 'Ошибка загрузки данных')
          })
        }
        return response.json()
      })
      .then((data) => {
        this.setState({
          items: data.items || [],
          loading: false,
          modalPage: data.page || 1,
          modalTotalPages: data.total_pages || 1,
        })
      })
      .catch((err) => {
        this.setState({ loading: false })
        toastr.error(err.message || 'Ошибка загрузки данных')
      })
  }

  toggleItem(id) {
    this.setState((prev) => {
      const selectedIds = new Set(prev.selectedIds)
      if (selectedIds.has(id)) selectedIds.delete(id)
      else selectedIds.add(id)
      return { selectedIds }
    })
  }

  apply() {
    const { selectedIds, isModalSelectedAll } = this.state
    const ids = Array.from(selectedIds)
    if (ids.length === 0 && !isModalSelectedAll) {
      toastr.warning('Выберите сотрудника')
      return
    }

    const token = localStorage.getItem('auth_access_token')
    this.setState({ applying: true })
    fetch(`/api/${this.props.project_name}/bulk_activate_drafts`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
      body: JSON.stringify({ ids: ids, is_selected_all: isModalSelectedAll}),
    })
      .then(async (response) => {
        const data = await response.json().catch(() => ({}))
        if (!response.ok) throw new Error(data.detail || 'Ошибка при выполнении операции')
        return data
      })
      .then((data) => {
        const updated = data.updated_count || 0
        const errors = data.errors || []
        if (updated > 0) {
          toastr.success(`Переведено карточек: ${updated}`)
        }
        errors.forEach((e) => {
          toastr.warning(`ID ${e.id}: ${e.message || 'Ошибка перехода'}`, 'Не переведено')
        })
        $(`#${MODAL_ID}`).modal('hide')
        this.setState({ applying: false }, () => {
          if (this.props.onApplySuccess) {
            this.props.onApplySuccess()
          }
        })
      })
      .catch((err) => {
        this.setState({ applying: false })
        toastr.error(err.message || 'Ошибка при выполнении операции')
      })
  }

  handleSelectAllFound(isCancelSelected) {
    if (isCancelSelected) this.setState({isModalSelectedAll: false, selectedIds: new Set()})
    else this.setState({isModalSelectedAll: true, selectedIds: new Set()})
  }

  render() {
    const {
      items,
      selectedIds,
      loading,
      applying,
      modalPage,
      modalTotalPages,
      isModalSelectedAll,
    } = this.state

    const selectedCount = Array.from(selectedIds).length;
    const totalCount = Array.from(items).length;

    const isCancelSelected =
      (isModalSelectedAll && selectedCount === 0) ||
      (selectedCount === totalCount && !isModalSelectedAll);

    return (
      <div className="modal fade" id={MODAL_ID} tabIndex="-1" aria-hidden="true">
        <div className="modal-dialog modal-lg" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">
                <i className="ti ti-arrows-transfer-up me-1"></i>
                Перевести на этап Действующий
              </h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
              <div className="card mb-3 card-body">
                <div className="col-md-12 mt-2">
                  <button className="btn btn-secondary btn-sm" onClick={() => this.handleSelectAllFound(isCancelSelected)}>
                    {isCancelSelected ? 'Отменить выбор' : 'Выбрать все'}
                  </button>
                </div>
              </div>
            <div className="modal-body">
              <div className="table-responsive" style={{ position: 'relative' }}>
                {/* Оверлей загрузки поверх таблицы */}
                {loading && (
                  <div className="d-flex justify-content-center align-items-center"
                       style={{ position: 'absolute', inset: 0, background: 'rgba(255,255,255,0.75)', zIndex: 10, borderRadius: '4px' }}>
                    <div className="spinner-border text-primary" role="status">
                      <span className="visually-hidden">Загрузка...</span>
                    </div>
                  </div>
                )}

                <table className="table table-sm table-hover" style={{ transition: 'opacity 0.2s', opacity: loading ? 0.6 : 1 }}>
                  <thead>
                    <tr>
                      <th style={{ width: '40px' }}></th>
                      <th>ФИО</th>
                      <th>Этап</th>
                    </tr>
                  </thead>
                  <tbody>
                    {items.length === 0 && !loading ? (
                      <tr>
                        <td colSpan={3} className="text-center text-muted py-4">
                          Нет карточек на этапе «Черновик»
                        </td>
                      </tr>
                    ) : (
                      items.map((item) => (
                        <tr key={item.id}>
                          <td>
                            <input
                              type="checkbox"
                              className="form-check-input"
                              checked={
                                (this.state.isModalSelectedAll && !selectedIds.has(item.id)) ||
                                (!this.state.isModalSelectedAll && selectedIds.has(item.id))
                              }
                              onChange={() => this.toggleItem(item.id)}
                              disabled={loading || applying}
                            />
                          </td>
                          <td>{item.name || '—'}</td>
                          <td>{item.state_title || item.state || '—'}</td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>

              {modalTotalPages > 1 && (
                <nav className="mt-3">
                  <ul className="pagination pagination-sm justify-content-center mb-0">
                    <li className={`page-item ${modalPage === 1 ? 'disabled' : ''}`}>
                      <button
                        type="button"
                        className="page-link"
                        disabled={modalPage === 1}
                        onClick={(e) => {
                          e.preventDefault()
                          if (modalPage > 1) this.loadItems(e, modalPage - 1)
                        }}
                      >
                        Назад
                      </button>
                    </li>
                    {[...Array(modalTotalPages)].map((_, idx) => (
                      <li key={idx} className={`page-item ${modalPage === idx + 1 ? 'active' : ''}`}>
                        <button
                          type="button"
                          className="page-link"
                          onClick={(e) => {
                            e.preventDefault()
                            this.loadItems(e, idx + 1)
                          }}
                        >
                          {idx + 1}
                        </button>
                      </li>
                    ))}
                    <li className={`page-item ${modalPage === modalTotalPages ? 'disabled' : ''}`}>
                      <button
                        type="button"
                        className="page-link"
                        disabled={modalPage === modalTotalPages}
                        onClick={(e) => {
                          e.preventDefault()
                          if (modalPage < modalTotalPages) this.loadItems(e, modalPage + 1)
                        }}
                      >
                        Вперёд
                      </button>
                    </li>
                  </ul>
                </nav>
              )}
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary p-2 me-1" data-bs-dismiss="modal">
                Отмена
              </button>
              <button type="button" className="btn btn-primary p-2 me-1" onClick={this.apply} disabled={applying || loading}>
                {applying ? 'Применение...' : 'Применить'}
              </button>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
